/**
 * @brisa/ui · WelcomeToast
 *
 * Toast pós-onboarding com copy variável por user_type. Auto-dismiss 6s.
 */
'use client';
import * as React from 'react';

export interface WelcomeToastProps {
  message: string;
  onDismiss?: () => void;
  autoDismissMs?: number;
  dismissLabel?: string;
}

export function WelcomeToast({
  message,
  onDismiss,
  autoDismissMs = 6000,
  dismissLabel = 'Fechar mensagem',
}: WelcomeToastProps) {
  const [visible, setVisible] = React.useState(true);
  React.useEffect(() => {
    if (!autoDismissMs) return;
    const t = setTimeout(() => {
      setVisible(false);
      onDismiss?.();
    }, autoDismissMs);
    return () => clearTimeout(t);
  }, [autoDismissMs, onDismiss]);
  if (!visible) return null;
  return (
    <div role="status" aria-live="polite" className="brisa-welcome-toast">
      <span className="brisa-welcome-toast__message">{message}</span>
      <button
        type="button"
        onClick={() => {
          setVisible(false);
          onDismiss?.();
        }}
        aria-label={dismissLabel}
        className="brisa-welcome-toast__dismiss"
      >
        ✕
      </button>
    </div>
  );
}
